import { Alert } from 'components'

interface Props {
  isProcessing: boolean
}

export const AlertProcessing = ({ isProcessing }: Props) => {
  if (!isProcessing) {
    return <></>
  }

  return (
    <Alert
      color="warning"
      isOpen
      className="max-w-7xl mx-auto mt-5 mb-2 shadow-sm"
    >
      <p className="font-bold">Estamos trabalhando na publicação da vaga.</p>
      <span>
        Atualize a página em alguns minutos para ver todos os detalhes e se
        candidatar.
      </span>
    </Alert>
  )
}
